export const adsTxtSlice = set => ({
  adsTXTdata: null,
  resellerAdsTxtLines: null,
  checked: [],
  rechecked: false,
  domains: [],
  customEntriesOpen: false,
  selectedAdsTXTDomain: null,
  isCheckingAdsTxt: false,
});
